export default "__VITE_ASSET__BE53alJT__"